import { takeLatest, select, put } from 'redux-saga/effects';
import { actionTypes } from '../checkFacetStatus/actions';
import { get } from 'lodash';

import UPDATE_DATA from './updateData';
import { actionTypes as liteObjectsActionTypes } from '../../../NewTaxes/redux/liteObjects/actions';
import { startRequestSkipLoading as startRequestTaxes } from '../../../NewTaxes/redux/taxes/actions';

function* startUpdateProcess(action) {
  const payload = action.payload;
  if (!payload.recentData) {
    return;
  }

  const state = yield select();

  for (const item of UPDATE_DATA) {
    const itemImmutableState = get(state, item.path);
    if (!itemImmutableState) {
      continue;
    }

    const itemState = itemImmutableState.toJS();

    if (itemState.data) {
      yield put(item.loader());
    }
  }

  yield updateTaxesProcess();
}

function* updateTaxesProcess() {
  yield takeLatest(liteObjectsActionTypes.REQUEST_SUCCESS, updateTaxes);
}

function* updateTaxes({ payload }) {
  const ids = Object.keys(payload);
  yield put(startRequestTaxes(ids));
}

export default function* updateLoadedDataSaga() {
  yield takeLatest(actionTypes.REQUEST_SUCCESS, startUpdateProcess);
}
